import { gql } from '@apollo/client';

import { ProfileSectionFragment } from '../fragments';

export const GetProfileQuery = gql`
    query GetProfile {
        getProfile {
            id
            sections {
                ...ProfileSection
            }
        }
    }
    ${ProfileSectionFragment}
`;
